import { render, staticRenderFns } from "./InvoiceSurchargeEditForm.vue?vue&type=template&id=54c50361&"
import script from "./InvoiceSurchargeEditForm.vue?vue&type=script&lang=js&"
export * from "./InvoiceSurchargeEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports